export enum LoadingState {
  NOT_STARTED,
  LOADING,
  SUCCESS,
  ERROR,
}
